<template>
  <v-card outlined>
    <v-card-title>
      <v-row>
        <v-col cols="8" class="pb-3 pl-3">
          <span class="py-1 primary--text">{{ formEditTitle }}</span>
        </v-col>
        <v-col cols="4" align="end" class="pt-2 px-0 text-right">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="to-right" icon @click="closeModal">
                <v-icon v-bind="attrs" v-on="on">{{ closeIcon }}</v-icon>
              </v-btn>
            </template>
            <span>Cerrar</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pb-2">
      <v-form
        v-model="isFormValid"
        ref="form-edit-presentacion"
        form="form-edit-presentacion"
        id="form-edit-presentacion"
        @submit.prevent="savePresentacionConfirm()"
      >
        <v-row>
          <!-- Presentacion numero -->
          <v-col cols="3" class="py-0" v-if="this.presentacionEditItem && !isCopy">
            <v-text-field
              v-model="numeroPresenta"
              dense
              label="Número de presentación"
              disabled
              v-mask="'#####'"
              outlined
            >
            </v-text-field>
          </v-col>
          <!-- fecha presentacion -->
          <v-col cols="3" md="3" class="py-0">
            <v-menu
              ref="fecha-edit-presentacion"
              v-model="menuFechaDesde"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fechaDesdeSelected"
                  label="Fecha"
                  :append-icon="calendarIcon"
                  v-bind="attrs"
                  autocomplete="not"
                  hint="Formato DD/MM/AAAA"
                  @blur="fechaDesde = parseDateToIso(fechaDesdeSelected)"
                  outlined
                  dense
                  :disabled="isDetalle"
                  clearable
                  v-mask="'##/##/####'"
                  v-on="on"
                  :rules="rules.validDate"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fechaDesde"
                no-title
                @change="fechaDesdeSelected = formatDate(fechaDesde)"
                @input="menuFechaDesde = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <!-- duracion -->
          <v-col cols="3" class="py-0">
            <v-text-field
              v-model="duracion"
              dense
              label="Duración (min.)"
              :disabled="isDetalle"
              v-mask="'######'"
              outlined
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <!-- observaciones -->
          <v-col cols="12" class="py-0">
            <v-textarea
              v-model="observaciones"
              dense
              :disabled="isDetalle"
              :rules="[
                rules.maxLength(observaciones, 1000),
                rules.noStartWithSpaces,
              ]"
              label="Observaciones"
              auto-grow
              rows="1"
              outlined
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row v-if="!isDetalle">
          <v-col cols="12" class="py-0">
            <v-autocomplete
              ref="usuarios-autocomplete"
              v-model.trim="usuarioSelected"
              :items="participantesItems"
              :search-input.sync="usuariosAutocompleteInput"
              item-text="value"
              item-value="id"
              @change="usuarioChange(usuarioSelected)"
              :filter="customFilterUsuarios"
              outlined
              clearable
              return-object
              dense
              autocomplete="off"
              label="Participante"
            >
              <template slot="item" slot-scope="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.value }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <template v-slot:append>
                <v-progress-circular
                  indeterminate
                  size="28"
                  v-if="usuariosLoading"
                  color="primary"
                ></v-progress-circular>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="mt-n7">
          <v-col cols="12" md="12" class="py-5">
            <v-data-table
              class="elevation-2"
              :headers="usuariosHeaders"
              :items="usuariosItems"
              :loading="loading"
              :search="search"
              dense
              item-key="id"
              :hide-default-footer="usuariosItems.length > 10 ? false : true"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-row>
                    <v-col cols="3" align="start">
                      <h4 class="primary--text">Participantes</h4>
                    </v-col>
                    <v-col cols="6" align-self="center">
                      <v-text-field
                        v-model="search"
                        clearable
                        label="Buscar"
                        single-line
                        :append-icon="iconoSearch"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-toolbar>
              </template>
              <template v-if="!isDetalle" v-slot:[`item.actions`]="{ item }">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      size="20"
                      v-on="on"
                      @click="deleteUsuario(item)"
                    >
                      {{ deleteIcon }}
                    </v-icon>
                  </template>
                  <span>Eliminar usuario</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="mt-n3 pl-0 pr-6">
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        type="submit"
        :disabled="!isFormValid || this.usuariosItems.length == 0"
        v-if="!isDetalle"
        form="form-edit-presentacion"
      >
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import rules from "@/utils/helpers/rules";
import { mask } from "vue-the-mask";
import enums from "@/utils/enums/index.js";
export default {
  directives: { mask },
  name: "EditPresentacion",
  props: {
    presentacionEditItem: {
      type: Object,
    },
    isDetalle: {
      type: Boolean,
    },
    isCopy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      calendarIcon: enums.icons.CALENDAR_ICON,
      iconoSearch: enums.icons.SEARCH_ICON,
      deleteIcon: enums.icons.DELETE,
      closeIcon: enums.icons.CLOSE,
      isFormValid: false,
      loading: false,
      rules: rules,
      search: "",
      formEditTitle: "Editar presentación",
      observaciones: "",
      numeroPresenta: null,
      duracion: null,
      menuFechaDesde: false,
      fechaDesdeSelected: null,
      fechaDesde: null,
      usuariosItems: [],
      usuarioSelected: null,
      usuariosAutocompleteInput: null,
      banderaUsuariosselected: false,
      usuariosLoading: false,
      participantesItems: [],
    };
  },
  watch: {
    usuariosAutocompleteInput(val) {
      if (val && val.length >= 3) {
        this.getUsuariosFilter();
      }
    },
  },
  computed: {
    usuariosHeaders() {
      const baseHeaders = [{ text: "Nombre", value: "value" }];
      if (!this.isDetalle) {
        baseHeaders.push({
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "end",
        });
      }
      return baseHeaders;
    },
  },
  async created() {
    if (this.presentacionEditItem) {
      if (this.isCopy) {
        this.formEditTitle = "Copiar presentación";
        this.setPresentacionCopy(this.presentacionEditItem);
      } else {
        this.numeroPresenta = this.presentacionEditItem.numeroPresentacion;
        if (this.isDetalle) this.formEditTitle = "Detalle presentación";
        this.setPresentacionEdit(this.presentacionEditItem);
      }
    } else {
      this.formEditTitle = "Nueva presentación";
    }
  },
  methods: {
    ...mapActions({
      setAlert: "user/setAlert",
      getAllUsuarios: "presentaciones/getAllUsuarios",
      savePresentacion: "presentaciones/savePresentacion",
      getUsuariosByQuery: "presentaciones/getUsuariosByQuery",
    }),
    usuarioChange(data) {
      if (!data) return;
      if (this.usuariosItems.length > 0) {
        const resp = this.usuariosItems.some((x) => x.id == data.id);
        if (resp) {
          this.setAlert({
            type: "error",
            message: "Ya existe un usuario con el mismo nombre.",
          });
        } else {
          this.usuariosItems.push(data);
          this.sortUsuariosTable(this.usuariosItems);
        }
      } else {
        this.usuariosItems.push(data);
        this.sortUsuariosTable(this.usuariosItems);
      }
    },
    customFilterUsuarios(item, queryText) {
      return item.id || item.value.indexOf(queryText) > -1;
    },
    getUsuariosFilter() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(async () => {
        if (
          this.participantesItems?.some(
            (x) => x.value == this.usuariosAutocompleteInput
          )
        ) {
          return;
        } else if (!this.banderaUsuariosselected) {
          this.usuariosLoading = true;
          const response = await this.getUsuariosByQuery({
            input: this.usuariosAutocompleteInput,
          });
          this.$refs["usuarios-autocomplete"].cachedItems = [];
          this.participantesItems = response;
          this.usuariosLoading = false;
        }
      }, 1000);
    },
    setPresentacionEdit(item) {
      this.observaciones = item.observaciones;
      this.duracion = item.duracion;
      this.fechaDesde = this.parseDateToIso(item.fechaPres);
      this.fechaDesdeSelected = this.formatDate(this.fechaDesde);
      this.usuariosItems = item.usuarios;
      this.sortUsuariosTable(this.usuariosItems);
    },
    setPresentacionCopy(item) {
      // Prellenar datos pero sin número de presentación
      this.formEditTitle = "Copiar presentación";
      this.numeroPresenta = null;
      this.observaciones = item.observaciones;
      this.duracion = item.duracion;
      this.fechaDesde = this.parseDateToIso(item.fechaPres);
      this.fechaDesdeSelected = this.formatDate(this.fechaDesde);
      this.usuariosItems = (item.usuarios || []).map(u => ({ id: u.id, value: u.value }));
      this.sortUsuariosTable(this.usuariosItems);
    },
    async savePresentacionConfirm() {
      this.isFormValid = false;
      const data = {
        presentacionId:
          this.presentacionEditItem == undefined || this.isCopy
            ? 0
            : this.presentacionEditItem.numeroPresentacion,
        observaciones: this.observaciones,
        duracion: (this.duracion === '' || this.duracion === null || this.duracion === undefined)
          ? null
          : this.duracion,
        fechaPres: this.fechaDesde,
        usuarios: this.usuariosItems,
      };
      try {
        const res = await this.savePresentacion(data);
        if (res) {
          this.setAlert({ type: "success", message: "Guardado con éxito." });
          this.closeModal();
          this.isFormValid = true;
        }
      } catch (error) {
        this.isFormValid = true;
      }
    },
    deleteUsuario(item) {
      const index = this.usuariosItems.findIndex((u) => u.id === item.id);
      if (index !== -1) {
        this.usuariosItems.splice(index, 1);
      }
      this.setAlert({ type: "success", message: "Usuario eliminado." });
    },
    closeModal() {
      this.$emit("closeAndReload");
    },
    sortUsuariosTable(items) {
      items.sort((a, b) => {
        const nombreA = (a.value || "").toLowerCase();
        const nombreB = (b.value || "").toLowerCase();
        if (nombreA < nombreB) return -1;
        if (nombreA > nombreB) return 1;
        return 0;
      });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDateToIso(date) {
      if (!date) return null;
      if (date.length === 10) {
        const [day, month, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
    },
  },
};
</script>

<style scoped>
.label {
  opacity: 0.7;
}
/* ::v-deep .theme--light.v-input--is-disabled textarea {
  color: rgb(56, 56, 56);
}
::v-deep .theme--light.v-input--is-disabled input {
  color: rgb(56, 56, 56);
}
::v-deep .theme--light.v-input--is-disabled label {
  color: rgb(56, 56, 56);
}
::v-deep .theme--light.v-input--is-disabled switch {
  color: rgb(56, 56, 56);
} */
.center-input >>> input {
  text-align: center;
}
</style>